import httpClient from "../httpClient";
import { API_COMORBIDITY_DELETE } from "../config";

const deleteComorbidity = {
    delete: (id) => httpClient.delete(API_COMORBIDITY_DELETE + '/' + id),
};

export default deleteComorbidity;